
const STATUS_PENDENTE = 1
const STATUS_CONCLUIDO = 2
const STATUS_ERRO = 3

const DESCRICAO_STATUS = {
  [STATUS_PENDENTE]: 'Pendente',
  [STATUS_CONCLUIDO]: 'Concluído',
  [STATUS_ERRO]: 'Erro',
}

const COR_STATUS = {
  [STATUS_PENDENTE]: 'info',
  [STATUS_CONCLUIDO]: 'success',
  [STATUS_ERRO]: 'error',
}

export {
  STATUS_PENDENTE,
  STATUS_CONCLUIDO,
  STATUS_ERRO,

  DESCRICAO_STATUS,
  COR_STATUS,
}
